<template>
  <div>
    <EwSelect
      placeholder="Filter by Life Cycle state"
      v-model="modelValue"
      :options="statusOptions"
      optionLabel="title"
      optionValue="identifier"
      optionGroupLabel="label"
      optionGroupChildren="children"
      :clearable="true"
      clearIcon="tabler:x"
      :iconsInside="true"
      :filter="true"
      size="md"
      class="w-full"
      @update:modelValue="handleChange"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useAppConfig } from '@/composables/useAppConfig';
import { EwSelect } from '@arkit/ew-vue-components'

interface StatusItem {
  identifier: string
  title: string
}

interface StatusGroup {
  label: string
  children: StatusItem[]
}

const modelValue = defineModel<string | null>({ default: null })
const emit = defineEmits<{
  (e: 'change', val: string | null): void
}>()

const AppConfig = useAppConfig();

function handleChange(val: string | null) {
  emit('change', val)
}

const statusOptions = ref<StatusGroup[]>([])

onMounted(async () => {
  try {
    const response = await fetch(`${AppConfig.urls.statuses}?json=y`)
    const data = await response.json()
    if (data && Array.isArray(data.data)) {
      statusOptions.value = data.data
    }
  } catch (err) {
    console.error('Gabim gjatë marrjes së statusOptions:', err)
  }
})

</script>
